import React from 'react';
import PropTypes from 'prop-types';
import BannerWrapper from './bannerwrapper';

function InfoListItem({ children, styling, accent }) {
  if (children === undefined || children === null || children.length <= 0) {
    return null;
  }

  return (
    <BannerWrapper styling={styling} accent={accent}>
      {children}
    </BannerWrapper>
  );
}

InfoListItem.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired,
  styling: PropTypes.string,
  accent: PropTypes.bool
};

InfoListItem.defaultProps = {
  styling: 'primary',
  accent: false
};

export default InfoListItem;
